import {customElement, property, query, state} from "lit/decorators";
import pdqS3Service, {MetadataKey, Schema} from "../services/PdqS3Service";
import {html, LitElement, nothing, PropertyValues} from "lit";
import {col, margin, marginBottom, row} from "../styles";

import "@carbon/web-components/es/components/skeleton-placeholder";
import "@carbon/web-components/es/components/inline-loading";
import "@carbon/web-components/es/components/structured-list";
import "@carbon/web-components/es/components/tabs";
import {combine, distinct} from "../observable/ReplaySubject";

@customElement('pdq-s3-file-metadata')
export class PdqS3FileMetadata extends LitElement {
    @property({type: String}) prefix = '';
    @property({type: String}) filename = '';

    @property({type: Object}) metadata: any = {};
    @property({type: Object}) schemas: Map<string, Schema>|undefined = undefined

    @query('cds-combo-box#add-metadata') structuredList: any;
    @state() addMetadataSelection = '';

    #unusedSchmeas: any = [];
    #usedSchmeas: any = [];
    #key: MetadataKey | undefined;

    static styles = [
        ...margin, ...marginBottom
    ]
    constructor() {
        super();
        combine(pdqS3Service.metadata, pdqS3Service.schemas).subscribe(i => {
            console.log('combine', i)
            const [metadata, schemas]: [Map<MetadataKey, any>, Map<string,any>] = i as any;
            if(!this.#key)
                return;

            if (metadata.has(this.#key)) {
                this.metadata = metadata.get(this.#key)
            }
            this.schemas = schemas


            const unused = [];
            const used = [];
            for (const k in this.metadata) {
                used.push(this.schemas.get(k))
            }
            for (const k of this.schemas.keys()) {
                console.log(k, this.metadata, this.metadata[k] )
                if (!(k in this.metadata)) {
                    unused.push(this.schemas.get(k))
                }
            }
            this.#unusedSchmeas = unused;
            this.#usedSchmeas = used;

            console.log('unused', unused)
            console.log('used', used)
        })
    }

    updated(changedProperties: PropertyValues) {
        console.log('updated', changedProperties)
        if (this.prefix && this.filename) {
            const key = pdqS3Service.getMetadataKey(this.prefix, this.filename);
            if (this.#key !== key) {
                this.#key = key;
                pdqS3Service.refreshMetadata(this.#key);
            }
        }
    }

    render() {
        if (!this.schemas || !this.prefix || !this.filename)
            return html`<cds-inline-loading class="m-2" status="active">Loading data...</cds-inline-loading>`;

        return html`
            <div class="row m-2">
                <div class="col">
                    <cds-skeleton-placeholder></cds-skeleton-placeholder>
                    ${this.filename}
                </div>
                <div class="col">
                    ${this.renderMetadatas()}
                </div>
            </div>
        `
        // ${this.renderAddSchema()}

    }
    renderMetadatas(){
        const tabsInUse = this.#usedSchmeas.map((i:any) => html`
            <cds-tab id="tab-${i.key}" value="${i.key}" target="schema-pannel-${i.key}">
                <cds-tab-header>${i.title}</cds-tab-header>
            </cds-tab>
        `)
        const tabsNotInUse = this.#unusedSchmeas.map((i:any) => html`
            <cds-tab id="tab-${i.key}" value="${i.key}" target="schema-pannel-${i.key}">
                <cds-tab-header>${i.title}</cds-tab-header>
            </cds-tab>
        `)
        const content = this.#usedSchmeas.map((i:any) => html`
            <cds-tab-panel id="schema-pannel-${i.key}">
                ${this.renderMetadata(i)}
            </cds-tab-panel>
            `)
        const content2 = this.#unusedSchmeas.map((i:any) => html`
            <cds-tab-panel id="schema-pannel-${i.key}">
                ${this.renderMetadata(i)}
            </cds-tab-panel>
            `)

        return html`<cds-tabs class="mb-2">${tabsInUse}${tabsNotInUse}</cds-tabs>${content}${content2}`
        //return this.#usedSchmeas.map((i:any) => this.renderMetadata(i))
    }
    renderMetadata(schema:Schema){
        const formData = JSON.parse(this.metadata[schema.key] || '{}');
        const uiSchema = {}

        return html`
                <dpl-schema-form
                        .schema="${schema.rawSchema}"
                        .formData="${formData}"
                        @formChange="${(e:any) => console.log(`${schema.title} form onChange`, e.detail)}"
                        @formSubmit="${(e: CustomEvent) => this.setMetadata(schema, e.detail)}"
                ></dpl-schema-form>
    `

    }
    renderAddSchema(){
        if(this.#unusedSchmeas.length === 0)
            return nothing;
        console.log(this.#unusedSchmeas)
        return html`
            <cds-combo-box id="add-metadata" label="Add Metadata"
                           @cds-combo-box-beingselected="${this.addSchema}"
                           .value="${this.addMetadataSelection}"
            >
                ${this.#unusedSchmeas.map((i: Schema) => html`
                    <cds-combo-box-item value="${i.key}">${i.title}</cds-combo-box-item>
                `)}
            </cds-combo-box>
        `
    }

    addSchema(event: CustomEvent){
        event.preventDefault()
        event.stopImmediatePropagation()
        console.log(event)
        const schema = this.schemas?.get(event.detail.item.value)!
        this.#unusedSchmeas = this.#unusedSchmeas.filter((i:any) => i !== schema)
        this.#usedSchmeas = [...this.#usedSchmeas, schema]
        const newMeta = {...this.metadata}
        newMeta[schema.key] = schema.default || '{}'
        this.metadata = {...newMeta}


    }

    setMetadata(schema:Schema, data:any){
        const newMeta = {...this.metadata}
        newMeta[schema.key] = data
        this.metadata = {...newMeta}

        pdqS3Service.setMetadata(this.prefix, this.filename, schema.key, data.formData)

    }
}
